import React from "react";
import List from "@mui/material/List";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";
import FileListDataManager from "./FileListDataManager";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {store} from "../../../redux/store";
import { sortByChanged, sortDirectionChanged } from "./fileListSlice";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import SortBy from "../../../components/list/sort/SortBy";
import SortDirection from "../../../components/list/sort/SortDirection";

export default function FileListSortConfig () {
    const requestParams = useSelector((state) => state.fileList.requestParams)
    const loadData = useDebouncedCallback(() => {
        FileListDataManager.load()
    }, 1000)

    if (!requestParams) {
        return <></>
    }

    return (
        <>
            <List>
                <SortBy>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('upload-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'upload-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-upload-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-upload-date" primary="Daty zapisu"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('publication-from-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'publication-from-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-publication-from-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-publication-from-date" primary="Daty publikacji (od)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('publication-thru-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'publication-thru-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-publication-thru-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-publication-thru-date" primary="Daty publikacji (do)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('pin-from-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'pin-from-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-pin-from-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-pin-from-date" primary="Daty przypięcia (od)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('pin-thru-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'pin-thru-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-pin-thru-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-pin-thru-date" primary="Daty przypięcia (do)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('name'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'name'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-name'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-name" primary="Nazwy"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('size'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'size'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-size'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-size" primary="Rozmiaru"/>
                        </ListItemButton>
                    </ListItem>
                </SortBy>

                <SortDirection>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('asc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'asc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-asc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-asc" primary="Rosnąco"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('desc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'desc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-desc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-desc" primary="Malejąco"/>
                        </ListItemButton>
                    </ListItem>
                </SortDirection>
            </List>
        </>
    )
}